import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Check, Phone, Sparkles } from "lucide-react";
import { AUDIO_GUESTBOOK, waLink } from "@/data/site";
import CTASection from "@/components/CTASection";
import PackagesGrid from "@/components/PackagesGrid";
import ComboSection from "@/components/ComboSection";
import { SERVICE } from "@/constants/testIds";

const AudioGastenboek = () => {
  return (
    <>
      <section className="relative h-[85vh] overflow-hidden">
        <img
          src={AUDIO_GUESTBOOK.hero}
          alt="Audio Gastenboek"
          className="absolute inset-0 w-full h-full object-cover animate-ken-burns"
        />
        <div className="absolute inset-0 bg-black/60" />
        <div className="relative z-10 h-full flex flex-col justify-end pb-24 container-x">
          <p className="eyebrow text-gold mb-4">Audio Gastenboek</p>
          <h1 className="font-serif text-white text-6xl md:text-7xl lg:text-8xl leading-[1.02] max-w-3xl">
            Hun stem — <span className="italic text-gold">voor altijd.</span>
          </h1>
        </div>
      </section>

      {/* Intro */}
      <section className="bg-beige py-24 md:py-32">
        <div className="container-narrow grid grid-cols-1 md:grid-cols-12 gap-12 items-center">
          <div className="md:col-span-5">
            <div className="relative aspect-square bg-white p-10 flex items-center justify-center">
              <Phone size={120} className="text-gold" strokeWidth={0.8} />
              <div className="absolute inset-0 border border-gold/40 m-4 pointer-events-none" />
            </div>
          </div>
          <div className="md:col-span-7">
            <p className="font-serif text-2xl md:text-3xl leading-snug">{AUDIO_GUESTBOOK.intro}</p>
            <p className="mt-6 font-script text-gold text-4xl">Elke stem, een herinnering.</p>
            <ul className="mt-8 space-y-2">
              {AUDIO_GUESTBOOK.highlights.map((h) => (
                <li key={h} className="flex items-start gap-2 text-sm text-neutral-700">
                  <Check size={14} className="text-gold mt-1 shrink-0" />
                  <span>{h}</span>
                </li>
              ))}
            </ul>
            <a
              data-testid={`${SERVICE.bookBtn}-audio-info`}
              href={waLink("Hallo Eric, ik wil graag info over het Audio Gastenboek voor mijn feest.")}
              target="_blank"
              rel="noreferrer"
              className="btn-gold mt-10"
            >
              Vraag vrijblijvend info
            </a>
          </div>
        </div>
      </section>

      {/* Packages */}
      <section className="bg-white py-24 md:py-32">
        <div className="container-x">
          <div className="text-center max-w-2xl mx-auto mb-14">
            <p className="eyebrow mb-3">Pakketten</p>
            <h2 className="font-serif text-4xl md:text-5xl">Voor elke gelegenheid</h2>
          </div>
          <PackagesGrid packages={AUDIO_GUESTBOOK.packages} serviceName="Audio Gastenboek" />
        </div>
      </section>

      {/* Cross-link to Magic Mirror */}
      <section className="bg-ink text-white py-24 md:py-32">
        <div className="container-narrow text-center max-w-2xl mx-auto">
          <Sparkles size={22} className="text-gold mx-auto mb-4" />
          <h2 className="font-serif text-4xl md:text-5xl leading-tight">
            Combineer met de <span className="italic text-gold">Magic Mirror.</span>
          </h2>
          <p className="mt-5 text-white/70 leading-relaxed">
            Foto's leggen de blikken vast, audio bewaart de stemmen. Samen vormen ze een compleet aandenken van jouw avond — inbegrepen in ons Premium feestpakket.
          </p>
          <Link to="/magic-mirror" className="btn-gold mt-10">
            Ontdek Magic Mirror
          </Link>
        </div>
      </section>

      {/* Combos */}
      <ComboSection ids={AUDIO_GUESTBOOK.combos} title="Combineer voor meer beleving" />

      <CTASection />
    </>
  );
};

export default AudioGastenboek;
